var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-list-item",
        { attrs: { "show-handle": "" } },
        [
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.filterText))]),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("edit-filter"),
                      expression: "$ct('edit-filter')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.editFilter()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "edit" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("remove-filter"),
                      expression: "$ct('remove-filter')",
                    },
                  ],
                  staticClass: "danger",
                  on: {
                    click: function ($event) {
                      return _vm.removeFilter()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-transition-slide-height",
        [
          _vm.isEditing
            ? _c("app-filter-edit", {
                attrs: { model: _vm.model, browse: _vm.browse },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }